import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import TertiaryButton from '../../../lib/ui/buttons/TertiaryButton';
import PaginationStart from '../../../assets/icons/PaginationStart.svg';
import PaginationStartDisabled from '../../../assets/icons/PaginationStartDisabled.svg';
import PaginationEnd from '../../../assets/icons/PaginationEnd.svg';
import PaginationEndDisabled from '../../../assets/icons/PaginationEndDisabled.svg';
import Backward from '../../../assets/icons/Backward.svg';
import BackwardDisabled from '../../../assets/icons/BackwardDisabled.svg';
import Forward from '../../../assets/icons/Forward.svg';
import ForwardDisabled from '../../../assets/icons/ForwardDisabled.svg';
import { PaginationContainer, PageNumber } from './css';

const PaginationControls = ({ currentPage, totalPages, setCurrentPageFn }) => {
  const handlePageFirst = () => {
    setCurrentPageFn(1);
  };

  const handlePagePrevious = () => {
    if (currentPage === 1) {
      return;
    }

    setCurrentPageFn(currentPage - 1);
  };

  const handlePageNext = () => {
    if (currentPage === totalPages) {
      return;
    }

    setCurrentPageFn(currentPage + 1);
  };

  const handlePageLast = () => {
    setCurrentPageFn(totalPages);
  };

  const handleClick = (e) => {
    setCurrentPageFn(Number(e.target.id));
  };

  const getPaginationRange = ({ currentPage, totalPages }) => {
    // Constants...
    const START_PAGE = 1;
    const DEFAULT_RANGE = 5;

    // Initializations...
    let range = DEFAULT_RANGE;

    if (range > totalPages) {
      range = totalPages;
    }

    let start = currentPage - Math.floor(range / 2);
    start = Math.max(start, START_PAGE);
    start = Math.min(start, START_PAGE + totalPages - range);

    return Array.from(
      { length: range },
      (element, index) => start + index,
    );
  };

  const pages = getPaginationRange({ currentPage, totalPages });

  return (
    <PaginationContainer>
      <TertiaryButton
        label={t('First')}
        onClick={handlePageFirst}
        size="small"
        showArrow={false}
        iconSrc={PaginationStart}
        iconSrcDisabled={PaginationStartDisabled}
        isIconLeftPosition
        disabled={currentPage === 1}
      />
      <TertiaryButton
        label={t('Previous')}
        onClick={handlePagePrevious}
        size="small"
        showArrow={false}
        iconSrc={Backward}
        iconSrcDisabled={BackwardDisabled}
        isIconLeftPosition
        disabled={currentPage === 1}
      />
      {currentPage && totalPages && pages.map((page) => (
        <PageNumber
          key={page}
          id={page}
          onClick={handleClick}
          selected={(currentPage === page)}
        >
          {page}
        </PageNumber>
      ))}
      <TertiaryButton
        label={t('Next')}
        onClick={handlePageNext}
        size="small"
        showArrow={false}
        iconSrc={Forward}
        iconSrcDisabled={ForwardDisabled}
        disabled={currentPage === totalPages}
      />
      <TertiaryButton
        label={t('Last')}
        onClick={handlePageLast}
        size="small"
        showArrow={false}
        iconSrc={PaginationEnd}
        iconSrcDisabled={PaginationEndDisabled}
        disabled={currentPage === totalPages}
      />
    </PaginationContainer>
  );
};

PaginationControls.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPageFn: PropTypes.func,
};

export default PaginationControls;
